import React, { useRef } from 'react';
import type { SegmentOption } from '../../types/offboarding';
interface SegmentedControlProps<T extends string> {
  options: SegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel: string;
}
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel
}: SegmentedControlProps<T>) {
  const refs = useRef<(HTMLButtonElement | null)[]>([]);
  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const dir = e.key === 'ArrowRight' ? 1 : -1;
    const next = (index + dir + options.length) % options.length;
    onChange(options[next].value);
    refs.current[next]?.focus();
  };
  return <div className="-mx-1 overflow-x-auto px-1 pb-1" data-id="element-304" data-mp="2rblmc051mn3v">
      <div role="radiogroup" aria-label={ariaLabel} className="inline-flex rounded-lg border border-gray-300 bg-white p-0.5" data-id="element-305" data-mp="kk4bgezsn2vu">
        {options.map((option, index) => {
        const selected = option.value === value;
        return <button key={option.value} ref={el => refs.current[index] = el} type="button" role="radio" aria-checked={selected} tabIndex={selected ? 0 : -1} onClick={() => onChange(option.value)} onKeyDown={e => handleKeyDown(e, index)} className={`whitespace-nowrap rounded-md px-3.5 py-2 text-[13px] font-medium transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-navy-600 ${selected ? 'bg-navy-600 text-white shadow-sm' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-306" data-mp="1htl189uxoslp" data-mpi={index}>
              {option.label}
            </button>;
      })}
      </div>
    </div>;
}